<template>
  <div class="care-record">
    <div class="service-name">服务订单</div>
    <div class="records">
      <div v-if="records && records.length === 0" class="no-record">
        <img src="@/assets/s-form-tjzl.png" /><i>无服务订单</i>
      </div>
      <div
        v-else
        class="item"
        v-for="(item, index) in records"
        :key="'record' + index"
        @click="gotoDetail(item.id, item.type)"
      >
        <div class="ico">
          <span v-if="item.service == null"><img :src="serviceBase[1].icon"/></span>
          <span v-else><img :src="item.service.icon"/></span>
        </div>
        <div class="time">
          <span class="title">{{item.name || '未知'}}</span>
          <!-- <span>剩余可使用1张，共{{item.total}}次</span> -->
          <span>{{ new Date(item.time && (item.time +"+08:00")).format("yyyy-MM-dd hh:mm") }}</span>
        </div>
        
        <div class="name">
          <span class="num">{{item.status}}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { httpOpen } from "../../scripts/network";
export default {
  name: "CareRecord",
  data() {
    return {
      id: 0,
      serviceBase: {
          "1": {
            name: "免费贴膜",
            icon: require("../../assets/ic_sticker.png"),
            type: 1,
            use: 0,
            total: 0,
            unit: "次",
          },
          "2": {
            name: "电池更换",
            icon: require("../../assets/ic_battery.png"),
            type: 2,
            use: 0,
            total: 0,
            unit: "次",
          },
          "3": {
            name: "屏幕更换",
            icon: require("../../assets/ic_screen.png"),
            type: 3,
            use: 2,
            total: 0,
            unit: "次",
          },
          "4": {
            name: "整机质保",
            icon: require("../../assets/ic_insurance.png"),
            type: 4,
            use: 0,
            total: 0,
            unit: "年",
            info: "保护中",
          },
            "5": {
                name: "后壳更换",
                icon: require("../../assets/card-qy-type-5.png"),
                type: 5,
                use: 0,
                total: 0,
                unit: "次"
            },
        },
      records: []
    };
  },
    watch: {
      name(value) {
        document.title = value
      }
    },
  created(){
    this.id = this.$route.params.id;
    this.loadData();
  },
  methods:{
    async loadData(){
      try {
          this.$loading.show()
       const ret = await httpOpen("/WuYouCard/GetServiceOrderList",{
          type:"post",
          body:{
            CardSysNo: this.id
          }
        })
        if (ret.Status){
             this.records = ret.Data ? ret.Data.map(item => {
               return {
                 id: item.SysNo,
                 type: item.EquityType,
                 name: item.EquityTypeName,
                 time: item.CreatedDate,
                 status:item.OrderStatusName,
                 total:item.EquityTotalCount,
                 service: this.serviceBase[item.EquityType]
               }
             }) : []
        }else{
          this.$toast("加载失败")
        }
      } catch (e) {
        console.error(e)
      } finally {
          this.$loading.hide()
      }
    },
    gotoDetail(id, equityType) {
      console.log(id)
      this.$router.push({
        name: "CardOrderDetail",
        params: {id: id},
        query: {equityType: equityType}
      });
    }
  }
};
</script>

<style lang="less">
.care-record {
  min-height: 100vh;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  background-color: #f4f4f4;
  .no-record{
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: black;
    background-color: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: 68px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      margin-bottom: 27px;
    }
    i{
      font-style: normal;
      font-size: 17px;
      font-weight: 600;
    }
  }
  .service-name{
    width: 100%;
    padding: 13px 18px;
    box-sizing: border-box;
    font-size: 15px;
    font-weight: 600;
  }
  .bg {
    position: fixed;
    z-index: -1;
    text-align: center;
    width: 100%;
    height: 100vh;
    img {
      height: 14px;
      margin-top: 25px;
    }
    
    &,&[type="10"] {
      background: linear-gradient(
        to bottom,
        #e9f5ff 0%,
        #f1f5f8 40%,
        #f1f5f8 100%
      );
    }
    &[type="20"] {
      background: linear-gradient(
        to bottom,
        #f1e0ba 0%,
        #f1f5f8 40%,
        #f1f5f8 100%
      );
    }
  }

  .records {
    padding: 0 16px;
    .item {
      background: white;
      border-radius: 6px;
      display: flex;
      align-items: center;
      .ico{
        margin: 0 8px 0 8px;
        //margin-right: 8px;
        >span{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 36px;
          height: 36px;
          border-radius: 100%;
          background: linear-gradient(325deg,rgba(50,50,50,0.84) 8%, rgba(0,0,0,0.84) 92%);
          text-align: center;
          img{
            width: 15px;
            height: 20px;
          }
        }
      }
      .time{
        display: flex;
        flex-direction: column;
        text-align: left;
        color: #5C5C5C;
        padding: 20px 30px 20px 10px;
        position: relative;
        width: 70%;
        &:before{
          content: '';
          position: absolute;
          top:20px;
          right: 0;
          width: 1px;
          bottom: 20px;
          background-color: #D9D9D9;
        }
        .title{
          font-size: 17px;
          color: #000;
          font-weight: 600;
        }
      }
      .name {
        font-size: 12px;
        color: #666666;
        display: flex;
        flex-direction: column;
        line-height: 1.5;
        padding: 20px 30px;
        position: relative;
        text-align: center;
        width: 30%;
        &:before{
          content: '';
          position: absolute;
          top:-10px;
          left: -10px;
          width: 20px;
          height: 20px;
          border-radius: 100%;
          background-color: #f4f4f4;
        }
        &:after{
          content: '';
          position: absolute;
          bottom:-10px;
          left: -10px;
          width: 20px;
          height: 20px;
          border-radius: 100%;
          background-color: #f4f4f4;
        }
        .num{
          font-size: 16px;
          font-weight: 600;
          color: #000;
        }
      }
    }
    .item + .item {
      margin-top: 16px;
    }
  }
}
</style>